import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React, { useState } from 'react';
import Button from '../../../../../../components/Button';
import Modal from '../../../../../../components/Modal';
import Form from '../../../../../../components/Form';
import { submitFeedback } from '../../../../../../api/submit-feedback';
var SubmissionState;

(function (SubmissionState) {
  SubmissionState["NotSubmitted"] = "notSubmitted";
  SubmissionState["Submitting"] = "submitting";
  SubmissionState["Complete"] = "complete";
})(SubmissionState || (SubmissionState = {}));

export var FeedbackModal = function FeedbackModal(_ref) {
  var source = _ref.source,
      swicusOrgId = _ref.swicusOrgId,
      environment = _ref.environment,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onFeedbackComplete = _ref.onFeedbackComplete;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      feedback = _useState2[0],
      setFeedback = _useState2[1];

  var _useState3 = useState(SubmissionState.NotSubmitted),
      _useState4 = _slicedToArray(_useState3, 2),
      submissionState = _useState4[0],
      setSubmissionState = _useState4[1];

  var isCompleted = submissionState === SubmissionState.Complete;
  var isSubmitting = submissionState === SubmissionState.Submitting;
  var exitButtonText = isCompleted ? 'Continue to the old experience' : 'No, thanks';
  var header = isCompleted ? 'Thank you so much!' : 'Before you go…';
  return /*#__PURE__*/React.createElement(Modal, {
    "data-qa": "feedback-modal",
    open: isOpen,
    onClose: isCompleted ? onContinue : onClose,
    size: "tiny",
    className: "cloud-ui-feedback-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, null, header), /*#__PURE__*/React.createElement(Modal.Content, null, isCompleted ? /*#__PURE__*/React.createElement("div", {
    className: "success"
  }, "Your feedback is extremely valuable in helping us improve the APM Integrated Experience and is very much appreciated.") : /*#__PURE__*/React.createElement(Form, {
    id: "feedback-form",
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement("textarea", {
    placeholder: "To help our team improve the APM Integrated Experience, can you let us know why you're switching back?",
    onChange: function onChange(e) {
      return setFeedback(e.target.value);
    },
    value: feedback // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: true,
    required: true,
    readOnly: isSubmitting
  }))), /*#__PURE__*/React.createElement(Modal.Actions, null, !isSubmitting && /*#__PURE__*/React.createElement(Button, {
    content: exitButtonText,
    onClick: onContinue,
    primary: isCompleted
  }), !isCompleted && /*#__PURE__*/React.createElement(Button, {
    form: "feedback-form",
    type: "submit",
    disabled: isSubmitting || !feedback,
    primary: true,
    loading: isSubmitting
  }, "Give Feedback")));

  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              setSubmissionState(SubmissionState.Submitting);
              _context.prev = 2;
              _context.next = 5;
              return submitFeedback(environment, swicusOrgId, feedback, source);

            case 5:
              onCompleted();
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              // If there was an error submitting feedback, we don't want to annoy
              // the user by making them wait any longer or jump through any
              // additional hoops, so just continue with toggling the experience off
              onContinue();

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  function onCompleted() {
    setSubmissionState(SubmissionState.Complete);
  }

  function onContinue() {
    if (typeof onFeedbackComplete === 'function') {
      onFeedbackComplete();
    } else if (typeof onClose === 'function') {
      onClose();
    }
  }
};
export default FeedbackModal;